import {Component, ElementRef, Input, OnInit, Renderer, ViewChild} from '@angular/core';

import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AuthService} from '../../../auth/auth.service';
import {HtmlUtilsService} from '../../../html-utils/html-utils.service';
import {MessageService} from '../../../messages/message.service';
import {TranslateService} from '../../translate.service';
import {FilterBlock} from '../../../search/search-list/filters/filter-block/filter-block';

@Component({
  selector: 'app-descriptor-metadata-modal',
  templateUrl: './descriptor-metadata-modal-component.html',
  styleUrls: ['./descriptor-metadata-modal-component.css']
})
export class DescriptorMetadataModalComponent {

  @ViewChild('modal') modal: ElementRef;

  @Input() data;

  @Input() properties;

  @Input() config;

  @Input() type: string;

  constructor(public translator: TranslateService,
              private messageService: MessageService,
              private formBuilder: FormBuilder,
              private http: HttpClient,
              public activeModal: NgbActiveModal,
              private renderer: Renderer,
              public htmlUtils: HtmlUtilsService,
              private authService: AuthService) {
  }

}
